// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__5wU7Y","logo":"style__logo__PgcIE","logoWithoutText":"style__logoWithoutText__vcDOs"};